export const defaults = {
	pageDetails: { pageNo: 1, pageSize: 50 }
};

export const COLUMNS_NAME_CONFISCATION_DETAILS = [
	'Confiscation Id',
	'UId',
	'TId',
	'Amount (₹D+W)',
	'Refund Type',
	'Confiscation Type',
	'Status',
	'Rejection Reason',
	'Created By',
	'Approved Or Rejected By',
	'Revert Tid',
	'Freshdesk Ticket Id/ Email Sub Line',
	'Created At',
	'Updated At'
];

export const SAMPLE_COLUMNS_NAME_CONFISCATION_DETAILS = [
	'UId',
	'TId',
	'Amount (₹D+W)',
	'Refund Type',
	'Confiscation Type',
	'Freshdesk Ticket Id/ Email Sub Line',
	'Reported On (MM-DD-YYYY)'
];
export const SAMPLE_COLUMNS_VALUES = [172674939409336, 60, 70, 'REFUND_TO_SOURCE', 'INITIATED', 1234567, '10-23-2024'];

export const KEYS_NAME_CONFISCATION_DETAILS = [
	'confiscationId',
	'uid',
	'tid',
	'amount',
	'refundType',
	'confiscationType',
	'status',
	'rejectionReason',
	'createdBy',
	'approvedOrRejectedBy',
	'revertTid',
	'freshdeskTicketId',
	'createdAt',
	'updatedAt'
];
